module.exports = __webpack_public_path__ + "static/img/iosDownload.b7827d6f.png";